<!-- 从题库的点击购买跳转过来，和 productList 展示一样，数据来源处理的逻辑不同-->
<template>
  <div :class="['productList', { inApp: $root.$data.isApp }]" id='yd-page5'>
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <!-- <div class="content"> -->
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :offset="20"
          v-if="courseList.length"
          @load="onLoad"
        >
          <ul class="courseList">
            <HotCourseCard v-for="(item, keys) in courseList" :key="keys" :item="item" />
          </ul>
        </van-list>
        <!-- loading -->
        <Loading ref="load" v-if="!courseList.length" />
        <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
        <Foot/>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { reqProducts, reqProductList } from '@/api/home';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';
import Loading from '../../components/loading/loading.vue';
import {deepCopy} from "@/utils/tools";

export default {
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
    Loading,
    Foot,
  },
  data() {
    return {
      courseList: [], // 课程列表
      currentPage: 1,
      totalPages: 0, // 总页数
      loading: false,
      finished: false,
      refreshing: false,
      stopPropagation: true,
      listEmpty: false, // 在loading时不显示缺省页
      downLoad: false, // 下拉加载判断不触发缺省页
    };
  },
  created() {
    this.$nextTick(() => {
      this.$refs.load.show = true;
    });
    this.getCourse(this.currentPage, 12);
  },
  mounted() {
  },
  beforeRouteLeave(to, from, next) {
    // 去详情页时设置 back, 从而在详情页点击返回时可以退回到此页面
    if (to.name === 'courseDetail') {
      sessionStorage.setItem('back', 'back');
    }
    next();
  },
  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      this.downLoad = true;
      if (this.courseList.length >= this.totalPages) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.currentPage += 1;
        this.getCourse(this.currentPage, 12);
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      this.downLoad = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.refreshing = true;
      this.currentPage = 1;
      this.getCourse(this.currentPage, 12);
    },
    // 请求产品列表
    async getCourse(pageNum, pageSize) {
      const {
        type, productId, productCategoryId, productAttributeJson,
      } = this.$route.query;
      let res = [];
      if (Number(type) === 1) {
        // this.loading = true;
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProducts(productId.split(','), endPoint);
        if (res.code === 0 && res.data) {
          if (this.refreshing) {
            this.courseList = [];
          } else {
            // 初始请求是全局loading不显示，下拉时不需要加载全局loading
            this.$refs.load.show = false;
          }
          this.refreshing = false;
          this.loading = false;
          this.resetProductData(res.data);
          this.totalPages = res.data.length;
          if (!res.data.length) {
            this.listEmpty = true;
          }
        } else {
          this.$refs.load.show = false;
          this.listEmpty = true;
          this.refreshing = false;
        }
      } else if (Number(type) === 2) {
        const attributeReqVOList = [];
        if (productAttributeJson && productAttributeJson.length > 6) {
          JSON.parse(productAttributeJson).forEach((item) => {
            Object.assign(item, { attributeValue: item.attributeValue });
            attributeReqVOList.push(item);
          });
        }
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProductList({
          attributeReqVOList,
          productCategoryIds: [productCategoryId],
          pageNum,
          pageSize,
          endPoint,
          company: 0,
          isShow: 1,
        });
        if (res.code === 0 && res.data) {
          // 下拉加载时不执行
          if (!this.downLoad) {
            if (this.refreshing) {
              this.courseList = [];
            } else {
              this.$refs.load.show = false;
            }
          }
          // if (this.refreshing) {
          //   this.courseList = [];
          // } else {
          //   this.$refs.load.show = false;
          // }
          this.refreshing = false;
          this.loading = false;
          this.resetProductData(res.data.data);
          if (!res.data.data.length) {
            this.listEmpty = true;
          }
          this.totalPages = res.data.total;
        } else {
          this.$refs.load.show = false;
          this.listEmpty = true;
          this.refreshing = false;
        }
      } else {
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProductList({
          productCategoryIds: productCategoryId.split(','),
          pageNum,
          pageSize,
          endPoint,
          company: 0,
          isShow: 1,
        });
        if (res.code === 0 && res.data) {
          // 下拉加载时不执行
          if (!this.downLoad) {
            if (this.refreshing) {
              this.courseList = [];
            } else {
              this.$refs.load.show = false;
            }
          }
          this.refreshing = false;
          this.loading = false;
          this.resetProductData(res.data.data);
          if (!res.data.data.length) {
            this.listEmpty = true;
          }
          this.totalPages = res.data.total;
        } else {
          this.$refs.load.show = false;
          this.listEmpty = true;
          this.refreshing = false;
        }
      }
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      this.courseList = [...this.courseList, ...courseList];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}
.productList {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 100px 36px 0 36px;
  background: #fefeff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .content {
    height: 100%;
  }
  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0 100px 0;
    background: #fff;
  }

  .courseList > li {
    position: relative;
    width: 686px;
    // height: 3.06px;
    // border: 1px solid red;
    // display: flex;
    // flex-wrap: nowrap;
    margin: 0 auto;
    margin-bottom: 25px;
    padding: 0.32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
    opacity: 1;
    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }
  ::v-deep .common-foot{
    position: fixed;
  }
}
</style>
